import MiscUtils from './MiscUtils'

const TeamUtils = {

  getDisplayName: fullName => {
    const names = fullName.trim().split(' ')
    return names[0]
  },

  createTeam: (companyInfo, userId, country) => {
    const displayName = TeamUtils.getDisplayName(companyInfo.fullName)
    const params = {
      user: {
        id: userId,
        displayName,
        country,
        email: companyInfo.email
      },
      team: {
        displayName: companyInfo.companyName,
        onboardedFrom: 'web'
      },
      userTeam: {
        role: companyInfo.role
      },
      onboarding: {
        fullName: companyInfo.fullName,
        displayName
      },
      helloMesage: 'I want to try out this app for team communication. Get the app here www.getfibo.com'
    }
    console.log('==>> createTeam: ', params)
    return MiscUtils.fetchEndPoint('createTeam', params)
  }

}

export default TeamUtils



// WEBPACK FOOTER //
// ./src/infra/TeamUtils.js